import React from 'react';
import PropTypes from 'prop-types';

import isEmpty from 'lodash/isEmpty';

import Select from '../../nucleus/select/select';
// Correct relative import for banner (file is in same directory)
import ConnectorRestrictionBanner from './connector-restriction-banner';
import useUserDealRestrictions from '../../hooks/useUserDealRestrictions';
import { categoryMap } from '../../constants/base';

const DealOverview = (props) => {
  const {
    dealType,
    setDealType,
    errorMessage,
    property,
  } = props;

  const dealTypes = [
    {
      display_name: 'Lease - Tenant',
      value: 'tenant',
      dataE2e: 'flyout-tenant',
    },
    {
      display_name: 'Lease - Landlord',
      value: 'landlord',
      dataE2e: 'flyout-landlord',
    },
    {
      display_name: 'Sale - Buyer',
      value: 'buyer',
      dataE2e: 'flyout-buyer',
    },
    {
      display_name: 'Sale - Seller',
      value: 'seller',
      dataE2e: 'flyout-seller',
    },
    {
      display_name: 'Consulting',
      value: 'consulting',
      dataE2e: 'flyout-consulting',
    },
    {
      display_name: 'Other',
      value: 'other',
      dataE2e: 'flyout-other',
    },
  ];

  const typeOfDeal = dealType || 'Select';

  const [showBanner, setShowBanner] = React.useState(false);
  const { restrictions } = useUserDealRestrictions();

  const isRestricted = (repRole) => {
    const dealTypeObj = dealTypes.find(dt => dt.value === repRole);
    
    if (!dealTypeObj || !restrictions?.length) return false;
    const value = dealTypeObj.value;
   
    const dealCategory = categoryMap[value] || value;
    // Check if any connector restriction includes this deal category
    return restrictions.some(
      r => r?.source_app === 'connector' && 
           Array.isArray(r?.restricted_deal_types) && 
           r.restricted_deal_types.includes(dealCategory)
    );  
  };

  const evaluateBanner = (repRole) => {
    const restricted = isRestricted(repRole);
    if (restricted) {
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  };

  const handleDealTypeChange = (selected) => {
    setDealType(selected);
    evaluateBanner(selected.value);
  };

  // Evaluate banner on mount and whenever dealType or restrictions change (covers duplicate deal initial state)
  React.useEffect(() => {
    if (typeof dealType === 'object' && dealType.value) {
      evaluateBanner(dealType.value);
    }
  }, [dealType, restrictions]);


  return (
    <>
      {showBanner && <ConnectorRestrictionBanner />}
      <section className="deal-overview">
        <div className="header">
          <h3>Deal Overview</h3>
        </div>
        <div className="field">
          <label>* Deal Type - Rep Role</label>
          <Select
            id="dealType"
            dataE2e="new-deal-flyout-button"
            disabled={!isEmpty(property)}
            defaultOption={!isEmpty(property) ? dealTypes[1] : typeOfDeal}
            options={dealTypes}
            onChange={handleDealTypeChange}
            errorMessage={errorMessage}
          />
        </div>
      </section>
    </>
  );
};

DealOverview.propTypes = {
  dealType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  setDealType: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  property: PropTypes.shape({}),
};

DealOverview.defaultProps = {
  errorMessage: '',
  property: {},
};
export default DealOverview;
